import { useMemo } from 'react';
import { Formula } from '../../interfaces/formula';
import { Flex } from '../UI-CHAKRA/Flex';
import FormulaSearchItem from './FormulaSearchItem';
import SearchResultItem from './SearchResultItem';

interface FormulaListProps {
  formulas: Formula[];
  onSelectFormula(formula: Formula): void;
  onOpenConfirmDialog(formulaId: number): void;
}

export default function FormulaList(props: FormulaListProps) {
  const { formulas, onSelectFormula, onOpenConfirmDialog } = props;

  const list = useMemo(() => {
    if (!formulas || formulas.length === 0) return;

    return (
      formulas.length > 0 &&
      formulas.map((formula) => {
        return (
          <SearchResultItem onClick={() => onSelectFormula(formula)} key={formula.id}>
            <FormulaSearchItem formula={formula} onOpenConfirmDialog={onOpenConfirmDialog} />
          </SearchResultItem>
        );
      })
    );
  }, [formulas, onSelectFormula, onOpenConfirmDialog]);

  return <Flex flexDir={'column'}>{list}</Flex>;
}
